import axios from 'axios'
import { host } from '../../helper/config'

const PLUGIN_NAME = 'admin-reward-calc-job'

const buildHeaders = (token) => ({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': token
})

export const getRewardCalcSetting = async (token) => {
    const response = await axios.post(`${host}/${PLUGIN_NAME}/setting/get`, {}, {
        headers: buildHeaders(token),
    })

    if (response && response.status === 200) {
        return response.data.config || null
    }
    return null
}

export const updateRewardCalcSetting = async (token, autoGames, autoPayGames, concurrency) => {
    const response = await axios.post(`${host}/${PLUGIN_NAME}/setting/update`, {
        autoGames: autoGames,
        autoPayGames: autoPayGames,
        concurrency: concurrency
    }, {
        headers: buildHeaders(token),
    })

    if (response && response.status === 200 && response.data.status === 1) {
        return response.data.config || null
    }
    return null
}

export const getRewardCalcJobs = async (token, gameId, page, period = '') => {
    const response = await axios.post(`${host}/${PLUGIN_NAME}/list`, {
        gameId: gameId,
        page: page,
        period: period
    }, {
        headers: buildHeaders(token),
    })

    if (response && response.status === 200) {
        return response.data || null
    }
    return null
}

export const createRewardCalcJob = async (token, gameId, gamePeriodId) => {
    const response = await axios.post(`${host}/${PLUGIN_NAME}/create`, {
        gameId: gameId,
        gamePeriodId: gamePeriodId
    }, {
        headers: buildHeaders(token),
    })

    if (response && response.status === 200) {
        return response.data || null
    }
    return null
}

export const retryRewardCalcJob = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGIN_NAME}/retry`, {
        id: id
    }, {
        headers: buildHeaders(token),
    })

    if (response && response.status === 200) {
        return response.data || null
    }
    return null
}
